var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertManagment',{attrs:{"default_filter":_vm.$route.params.filter}})}
var staticRenderFns = []

export { render, staticRenderFns }